/**
 * Paddle.js loader + overlay opener.
 *
 * Frontend never sees the API key, we ask the backend to create a
 * Paddle transaction first, then open the inline overlay against
 * that transaction_id. This keeps price logic + user identity
 * server-side and tamper-proof.
 */
import { initializePaddle } from "@paddle/paddle-js";

let paddleSingleton = null;

export async function getPaddle() {
  if (paddleSingleton) return paddleSingleton;
  const env = process.env.REACT_APP_PADDLE_ENV || "sandbox";
  const token = process.env.REACT_APP_PADDLE_TOKEN || "";
  if (!token) {
    throw new Error("Paddle client-side token missing. Check REACT_APP_PADDLE_TOKEN in frontend/.env.");
  }
  paddleSingleton = await initializePaddle({
    environment: env === "production" ? "production" : "sandbox",
    token,
  });
  return paddleSingleton;
}

/**
 * Open the Paddle overlay for an authenticated user.
 * `transactionId` comes from POST /api/subscription/checkout.
 */
export async function openPaddleCheckout({ transactionId, onCompleted, onClosed }) {
  const paddle = await getPaddle();
  paddle.Checkout.open({
    transactionId,
    settings: {
      displayMode: "overlay",
      theme: "dark",
      locale: "en",
      successUrl: `${window.location.origin}/dashboard?subscription=success`,
    },
    eventCallback: (e) => {
      if (e?.name === "checkout.completed" && onCompleted) onCompleted(e);
      if (e?.name === "checkout.closed" && onClosed) onClosed(e);
    },
  });
}
